import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ImageViewerComponent } from './image-viewer.component';

@Injectable({
  providedIn: 'root'
})
export class ImageViewerService {
  constructor (
    private modalService: NgbModal
  ) {}

  view ( src : string ) : void {
    const modal = this.modalService.open(ImageViewerComponent, {
      windowClass: 'pull-up x-lg-modal'
    });

    modal.componentInstance.src = src;
  }
}